<template>
    <div>
        <Spinner v-if="loading"> {{ loadingMessage }}</Spinner>

        <div v-else>

            <!-- ========================== EMPTY ACTIONS ====================== -->
            <div class="modal-body pb-1" v-if="options == null || options.length <= 0">
                <div class="text-center mt-3">
                    <div class="text-center">
                        <i class="title-icon warning"></i>
                    </div>

                    <h5 class="text-center mt-5 mb-5 gray" style="line-height:1.5;margin-top:6rem">No provider available
                        for this payment option. Kindly use other payment options</h5>

                </div>
            </div>
            <!-- ========================== EMPTY ACTIONS ====================== -->

            <!-- ========================== NOT EMPTY ====================== -->
            <div v-else>

                <!-- ========================== COMING SOON ====================== -->
                <div class="text-center mt-3" v-if="current_option == null || isComingSoon">
                    <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
                    <img v-if="current_option.image_url" :src="current_option.image_url" class="provider-logo" alt=""
                        style="width: 20%; height :auto" />
                    <h5 style="" class="mt-3 gray">Coming Soon</h5>
                    <p class="mt-3" style="font-size:14px;"> <strong>{{ current_option.option }}</strong> is under
                        development, please use other payment method.</p>
                </div>
                <!-- ========================== COMING SOON ====================== -->

                <div v-else>
                    <!-- ========================== OPTION LISTS ====================== -->
                    <div v-if="view == 'options'" class="row mx-0">
                        <p class="text-center heading mt-2 mb-0"
                            v-html="headingMessage || 'Select your preferred bank'"></p>

                        <div class="payment-methods">
                            <a class="" @click.prevent="selectOption(key)" :key="key" :id="'list-' + key"
                                v-for="(item, key) in chunk_items">
                                <div class="method ">
                                    <img :src="item.provider ? (item.image_url ? item.image_url : '/img/' + item.provider.toLowerCase() + '-logo.svg') : item.image_url"
                                        :alt="item.option" />
                                    <p class="content" v-html="item.option"></p>
                                </div>
                            </a>
                        </div>

                        <!-- PAGINATOR -->
                        <div v-if="this.data.details.action.length > client_info.paginate_count">
                            <Paginator
                                v-if="client_info.paginate_count > 0 && client_info.paginate_count > options.length ? client_info.paginate_count : (options.length > 5)"
                                :per_page="client_info.paginate_count" :items="options" @next="handleNext"
                                @prev="handlePrev" :page="current_page" />
                        </div>

                    </div>
                    <!-- ========================== OPTION LISTS ====================== -->

                    <!-- ======================== INSTRUCTION =============================-->
                    <div v-if="view == 'instruction'" class="row m-0 text-center">
                        <div class="col-12 px-0">
                            <!-- Cash Type -->
                            <div v-if="type == 'cash'" class="mt-2 text-center gray" v-html="headingMessage"></div>

                            <div v-else class="mt-2 text-center gray" v-html="headingMessage"></div>

                        </div>
                    </div>
                    <!-- ======================== INSTRUCTION =============================-->

                    <!-- ======================== SERVICE CALL =============================-->
                    <div v-else-if="view == 'service_call'" class="row m-0 text-center">

                        <div v-if="isCoralPay">
                            <!-- <h5 class="text-center heading mt-2 mb-0">Select your Bank's USSD</h5> -->

                            <div class="payment-methods">
                                <a class="" @click.prevent="selectUssdBank(key)" :key="key"
                                    v-for="(item, key) in chunk_banks_items">
                                    <div class="method ">
                                        <img :src="item.image_url" :alt="item.name" />
                                        <p class="content">{{ item.name }}</p>
                                        <!-- <p class="content">{{ item.name}} ({{ item.ussdString }})</p> -->
                                    </div>
                                </a>
                            </div>

                            <!-- PAGINATOR -->
                            <div class="mt-3 mb-0" v-if="banks.length > client_info.paginate_count">
                                <Paginator
                                    v-if="client_info.paginate_count > 0 && client_info.paginate_count > options.length ? client_info.paginate_count : (banks.length > 6)"
                                    :per_page="client_info.paginate_count" :items="banks" @next="handleNext"
                                    @prev="handlePrev" :page="current_page" />
                            </div>
                        </div>
                        <div v-else>
                            <h3 class="mt-2 text-center gray text-bold h3" v-html="headingMessage"
                                :class="isEnd ? 'mb-5' : ''"></h3>

                            <!-- ACCOUNT NO. -->
                            <p class="text-left" v-html="headingMessage"></p>
                            <input type="number" data-me class="form-control no-label" v-model="account_no"
                                maxlength="11" autocomplete="off" minlength="9" autofocus required
                                @focus="isFocus = true" @blur="isFocus = false"
                                onKeyPress="if(this.value.length == 11) return false;"
                                :style="{ borderColor: (isFocus ? client_info.colors.app_color : '#e4e4e4') }" />

                            <div class="form-group mt-3 mb-2">
                                <button :disabled="isCoralDisabled" type="submit" class="" :style="button_color"
                                    ref="btnActionPay" @click.prevent="callSendInvoice">
                                    Continue
                                </button>
                            </div>
                        </div>

                    </div>
                    <!-- ======================== SERVICE CALL =============================-->

                    <!-- ======================== SERVICE CALL OTP =============================-->
                    <div v-else-if="view == 'service_call_otp'" class="row m-0 text-center">

                        <div class="form-group ">
                            <p class="mt-2 text-center gray text-bold" v-html="headingMessage"
                                :class="isEnd ? 'mb-5' : ''"></p>
                            <form class="pay-otp-code mb-4">
                                <input type="number" class="form-control no-label text-center" v-model="otp"
                                    maxlength="10" autocomplete="off" minlength="4" autofocus required
                                    @focus="isFocus = true" @blur="isFocus = false"
                                    onKeyPress="if(this.value.length == 10) return false;"
                                    :style="{ borderColor: (isFocus ? client_info.colors.app_color : '#e4e4e4') }" />
                                <span class="invalid-feedback" :style="(errors.otp) ? 'display : inline' : ''">{{
            errors.otp }}</span>
                            </form>

                            <div id="new-saved" class="switch">
                                <a v-if="has_ussd" class="left active pointer mb-3" @mouseover="hover = true"
                                    @mouseleave="hover = false" href="javascript:void(0)"
                                    :style="hover ? hover_in_style : ''" @click.prevent="validateUssd"
                                    style="font-size:12px; border: solid 1px #000; color: #000; border-radius:3px; background:#fff;">
                                    I dialed the USSD code </a>
                            </div>

                            <button :disabled="otp.length <= 3" type="button" class="btn " :style="button_color"
                                @click.prevent="submitOtp">
                                Continue
                            </button>
                        </div>
                    </div>
                    <!-- ======================== SERVICE CALL OTP =============================-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue'
import Paginator from './includes/Paginator.vue'
import {
    coralPayBanks
} from './includes/banks.js';
import {
    EventBus
} from './includes/bus.js';

export default {
    name: 'transfer',
    props: {
        data: Object,
        client_info: Object,
        button_color: Object,
    },

    components: {
        Spinner,
        Paginator
    },
    computed: {
        isCoralDisabled() {
            return !(this.bank_code !== '' && this.account_no.length === 10)
        }
    },

    watch: {
        loading(val) {
            if (!val) {
                this.$emit('hideBack', true)
            } else {
                this.$emit('hideBack', false)
            }
        },
    },

    created() {
        EventBus.$on('global-back', payload => {
            if (payload.in_view.toLowerCase() == 'transfer' && payload.action == "back") {
                if (this.view != "instruction") {
                    this.changePaymentOption();
                } else {
                    this.view = "";
                    this.changeChoice();
                }
            }
        });

        if (this.data.details.action) {
            this.options = this.data.details.action
            this.headingMessage = this.data.details.message
            this.type = this.data.details.auth_type.toLowerCase()

            if (this.options.length === 0) {
                this.options = null;
                return;
            } else if (this.options.length === 1) {
                this.shouldShow = true;
                this.current_option = this.options[0];
                this.headingMessage = this.current_option.instructions
                this.selectOption(0);
            } else { // more than 1
                // Settle Pagination here
                this.chunk_items = this.data.details.action.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 6);
            }
        }

    },

    mounted() {
        /* this.hover_in_style = {
            background: this.client_info.colors.app,
            "border-color": this.client_info.colors.app,
            color: '#000',
            "border-radius": "3px;",
        };

        this.hover_out_style = {
            "font-size": "12 px;",
            "color": "#000;",
            "border": `solid 1px ${this.client_info.colors.app ||'#000'};`,
            "border-radius": "3px;",
        }; */
    },

    data() {
        return {
            isComingSoon: false,
            isEnd: false,
            isFocus: true,
            view: 'options',
            focusColor: '',
            options: [],
            current_option: {},
            type: '',
            longNameClass: 'width: 65%; margin-right: 5px; font-size :12px',
            loading: false,
            loadingMessage: 'loading.....',
            sendingOtp: false,
            sendingPhone: false,
            headingMessage: '',
            otp: '',
            current_page: 0,
            chunk_items: [],
            chunk_banks_items: [],
            isCoralPay: false,
            errors: {
                trx_otp: false,
                otp: '',
            },
            account_no: '',
            bank_code: '',
            hover_in_style: {},
            hover_out_style: {},
            has_ussd: false,
            hover: false,
        }
    },
    methods: {

        changePaymentOption() {

            if (this.view == 'service_call_otp') {
                this.$store.dispatch('transRef', this.$generateTransactionRef());
                this.$store.dispatch('isFailed', true);
            }

            this.$parent.changeComponent("PaymentOptions");
        },

        goBack() {
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = '';
            this.view = 'options'
        },

        changeChoice() {
            this.headingMessage = this.data.details.message
            this.current_page = this.current_option.page;
            this.current_option = '';
            this.view = 'options'
        },

        handlePrev(val) {
            this.current_page = val.page;
            if (this.isCoralPay)
                this.chunk_banks_items = val.data;
            else
                this.chunk_items = val.data;
        },

        handleNext(val) {
            this.current_page = val.page;
            if (this.isCoralPay)
                this.chunk_banks_items = val.data;
            else
                this.chunk_items = val.data;
        },

        handleProviderService(val) {
            // console.log(val);
            if (val.instructions)
                if (val.instructions.length > 15 && val.instructions != null) { // Show instruction
                    let instruction = val.instructions
                    instruction = instruction.replace('{{tranaction_ref}}', this.$store.state.transRef).replace('{{customer_ref}}', this.$store.state.payload.transaction.customer.customer_ref);
                    instruction = instruction.replace('{{provider}}', this.current_option.provider);
                    this.headingMessage = instruction;
                    this.view = 'instruction';
                } else { // instruction is a service call in OnePipe
                    this.$store.dispatch('service_call_payload', {});
                    this.view = 'service_call';

                    let vm = this;
                    switch (val.instructions.toLowerCase()) {
                        case "open account":
                        case "open_account":
                        case "account_opening":
                        case "account opening":
                            vm.callOpenAccount(val.instructions.toLowerCase());
                            break;

                        case "send_invoice":
                            if (this.current_option.provider.toLowerCase() === "coralpay") {
                                this.isCoralPay = true;
                                let sortedBanks = coralPayBanks.sort(this.$sortCompare)
                                this.banks = sortedBanks;
                                this.chunk_banks_items = sortedBanks.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 6);
                            } else {
                                vm.callSendInvoice();
                            }
                            break;
                    }
                }
        },

        selectOption(index) {
            const val = this.options[index];
            this.current_option = val;
            this.$emit('handTitle', val.option)

            if (val) {
                if (val.provider && (val.provider !== null || val.provider !== "")) {
                    if (val.provider.toLowerCase() === "comingsoon") { // Show coming soon
                        this.isComingSoon = true;
                    } else {
                        // console.log("Provider is present check for instruction");
                        this.handleProviderService(val);
                    }
                } else {
                    // console.log("Provider is null")
                    this.handleProviderService(val);
                }
            }
        },

        confirmPayment() {
            let res = JSON.parse(window.raw);
            res.message = "Transaction processed successfully";

            if (res.data.client_info)
                delete res.data.client_info;

            if (res.data.paymentoptions)
                delete res.data.paymentoptions;
            // console.log(res);

            delete res.data.client_info;

            window.raw = JSON.stringify(res);
            this.$parent.continueToMerchant({
                status: res.status,
                message: res.data.message,
            });

            return;
        },

        backToMerchant() {
            let res = JSON.parse(window.raw);
            res.message = "Transaction processed successfully";

            if (res.data.client_info)
                delete res.data.client_info;

            if (res.data.paymentoptions)
                delete res.data.paymentoptions;

            // console.log(res);

            delete res.data.client_info;

            window.raw = JSON.stringify(res);
            this.$parent.continueToMerchant({
                status: "Successful", // Overwrite the status as 'PendingValidation' since user would have to pay later.
                message: res.data.message,
            });

            return;
        },

        selectUssdBank(key) {
            const bank = this.banks[key];
            this.bank_code = bank.cbn_code;
            this.callSendInvoice()
        },

        async callOpenAccount(service) {

            this.loading = true;

            // Get initial payload
            const initialPayload = this.$parent.getInitialPayload();
            const customer = initialPayload.transaction.customer;
            // console.log(initialPayload);

            try {
                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: {
                        request_ref: this.$generateRequestRef(),
                        request_type: service,
                        auth: {
                            type: null,
                            secure: null,
                            auth_provider: this.current_option.provider,
                        },
                        transaction: {
                            transaction_ref: this.$store.state.transRef + '-js-oa',
                            transaction_desc: initialPayload.transaction.transaction_desc ? initialPayload.transaction.transaction_desc : "Open Account",
                        transaction_ref_parent: null,
                            amount: initialPayload.transaction.amount,
                            customer: customer,
                            details: {
                                name_on_account: `${customer.firstname} ${customer.surname}`,
                                middlename: null,
                                dob: null,
                                gender: null,
                                title: null,
                                address_line_1: null,
                                address_line_2: null,
                                city: null,
                                state: null,
                                country: null
                            }
                        }
                    },
                },

                    data = this.$generateToken(data2);

                this.$store.dispatch('service_call_payload', data2.payload);

                // console.log(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                })
                    .then(response => {
                        let hash = response.data.data,
                            res = this.$decodeToken(hash),
                            status = res.status.toLowerCase(),
                            message = res.message,
                            responseData = res.data;

                        window.raw = JSON.stringify(res);
                        // console.log(res);

                        if (status === "successful") {
                            this.loading = false;

                            if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                                // if (data2.payload.auth.auth_provider.toLowerCase() === 'monnify') {
                                let p_res = responseData.provider_response;
                                const currency = initialPayload.transaction.currency ? initialPayload.transaction.currency : (initialPayload.transaction.meta.currency ? initialPayload.transaction.meta.currency : 'NGN');
                                if (Object.keys(p_res).includes('accountNumber') || Object.keys(p_res).includes('account_number')) {
                                    message = `To complete your payment, kindly transfer ${currency}${initialPayload.transaction.amount / 100} to ${p_res.accountNumber || p_res.account_number} in ${p_res.bankName || p_res.bank_name} on behalf of ${p_res.accountName || p_res.account_name}.`
                                }
                            }

                            this.$parent.changeComponent('Status', {
                                type: 'Successful',
                                status_type: 'message',
                                data: responseData,
                                message: message
                            });

                        } else if (status === "waitingforotp" || status === "pendingvalidation") {
                            this.loading = false;
                            this.headingMessage = message;
                            this.open_account_otp = this.loadingMessage = '';
                            window.otp_provider = data2.payload.auth.auth_provider;

                            if (Object.keys(responseData).includes('provider_response') && Object.keys(responseData.provider_response).includes('meta')) {
                                if (Object.keys(responseData.provider_response.meta).includes('ussd_code')) {
                                    this.has_ussd = true;
                                    window.ussd_reference = responseData.provider_response.meta.reference;
                                    window.request_type = data2.payload.request_type;
                                    window.otp_transaction_ref = data2.payload.transaction.transaction_ref
                                }
                            }

                            this.view = "service_call_otp";
                            return true;

                        } else {
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                            this.loading = false;
                        }
                    }).catch(error => {
                        console.log(error);
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/mtn/warning');
                        this.loading = false;
                    });
            } catch (error) {
                console.log(error);
                window.failedFromStart = false;
                window.failedFromStartMessage = error;
                this.$router.push('/v2/mtn/warning');
                this.loading = false;
            }

        },

        submitOtp() {
            this.loading = true;
            this.loadingMessage = 'Validating...'
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: window.request_type,
                auth: {
                    secure: this.otp,
                    auth_provider: window.otp_provider
                },
                transaction: {
                    transaction_ref: window.otp_transaction_ref
                }
            },
                data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);

            // console.log(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);
                console.log(res);

                if (response.status === 200) {
                    if (status == "successful") {
                        this.loading = false;

                        if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                            let p_res = responseData.provider_response;
                            if (Object.keys(p_res).includes('accountNumber') || Object.keys(p_res).includes('account_number')) {
                                message = `To complete your payment, kindly transfer ₦${initialPayload.transaction.amount / 100} to ${p_res.accountNumber || p_res.account_number} in ${p_res.bankName || p_res.bank_name} on behalf of ${p_res.accountName || p_res.account_name}.`
                            }
                        }

                        this.$parent.changeComponent('Status', {
                            type: 'Successful',
                            status_type: 'message',
                            data: responseData,
                            message: message
                        });

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/mtn/warning');
                    }
                } else {
                    window.failedFromStartMessage = message || 'Unble to get error message';
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        validateUssd() {

            this.loading = true;
            this.loadingMessage = 'Validating...';

            let data = null,
                vm = this,
                endpoint = 'v2/onepipe/js';

            const initialPayload = this.$parent.getInitialPayload();

            const payload = {
                request_ref: this.$generateRequestRef(),
                request_type: window.request_type,
                auth: {
                    secure: window.ussd_reference,
                },
                transaction: {
                    transaction_ref: window.otp_transaction_ref
                }
            };

            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'validate',
                payload
            };

            data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);

                // console.log(res);

                if (response.status === 200) {
                    if (status == "successful") {
                        if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                            let p_res = responseData.provider_response;
                            const currency = initialPayload.transaction.currency ? initialPayload.transaction.currency : (initialPayload.transaction.meta.currency ? initialPayload.transaction.meta.currency : 'NGN');
                            if (Object.keys(p_res).includes('accountNumber') || Object.keys(p_res).includes('account_number')) {
                                message = `To complete your payment, kindly transfer ${currency}${initialPayload.transaction.amount / 100} to ${p_res.accountNumber || p_res.account_number} in ${p_res.bankName || p_res.bank_name} on behalf of ${p_res.accountName || p_res.account_name}.`
                            }
                        }

                        this.$parent.changeComponent('Status', {
                            type: 'Successful',
                            status_type: 'message',
                            data: responseData,
                            message: message
                        });
                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/mtn/warning');
                    }
                } else {
                    window.failedFromStartMessage = message || 'Unble to get error message';
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })

        },

        async callSendInvoice() {

            this.loadingMessage = 'Initializing...'
            this.loading = true;

            // get initial payload
            const initialPayload = this.$parent.getInitialPayload();
            const customer = initialPayload.transaction.customer;
            let data2 = {
                endpoint: 'transact',
                api_key: this.$store.state.api_key,
                payload: {
                    "request_ref": this.$generateRequestRef(),
                    "request_type": "send_invoice",
                    "auth": {
                        "type": 'bank.account',
                        "secure": `0987654321;${this.bank_code}`,
                        "auth_provider": this.current_option.provider
                    },
                    "transaction": {
                        "mock_mode": "live",
                        "transaction_ref": this.$store.state.transRef + '-js-si',
                        "transaction_desc": initialPayload.transaction.transaction_desc,
                        "transaction_ref_parent": null,
                        "amount": initialPayload.transaction.amount,
                        "customer": customer,
                    }
                }
            };

            this.$store.dispatch('service_call_payload', data2.payload);

            if (this.$store.state.isFailed)
                data2.payload.parentTransRef = this.$store.state.parentTransRef

            let data = this.$generateToken(data2);

            console.log(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {

                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;

                window.raw = JSON.stringify(res);
                console.log(res);

                if (response.status === 200) {
                    if (status == "successful") {
                        this.loading = false;

                        if (Object.keys(responseData).includes('provider_response') && Object.keys(responseData.provider_response).includes('meta')) {
                            if (Object.keys(responseData.provider_response.meta).includes('ussd_code')) {
                                message = `<p class="text-center gray">${responseData.provider_response.meta.additional_message}.</p><div class="col-12 px-0 mt-4 mb-5"><h2 class="emphasized text-center black">${responseData.provider_response.meta.ussd_code}</h2></div>`;
                            }
                        }

                        this.$parent.changeComponent('Status', {
                            type: 'Successful',
                            status_type: 'message',
                            data: responseData,
                            message: message
                        });

                    } else {
                        // this.loading = false;
                        window.failedFromStartMessage = message;
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                } else { // Server call
                    // this.loading = false;
                    window.failedFromStartMessage = message;
                    window.failedFromStart = false;
                    window.raw = JSON.stringify(res.data);
                    this.$router.push('/v2/mtn/warning');
                }
            })
                .catch(error => {
                    // this.loading = false;
                    window.raw = JSON.stringify(error);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = error;
                    this.$router.push('/v2/mtn/warning');
                })

        },

    }
};
</script>
